<template>
    <rkm-modal
        persistent
        ref="Modal"
        title="Profissional - Faturar procedimento laboratorial"
    >
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="usuarios"
                        :validations="validations.usuario"
                        label="Profissional"
                        show-default-option
                        text-field="nome"
                        v-model="form.usuarioId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="lotacoes"
                        :validations="validations.lotacao"
                        label="Ocupação"
                        show-default-option
                        text-field="ocupacaoDescricao"
                        v-model="model.lotacaoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template #footer>
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                color="primary"
                @click="$refs.Form.validate(save)"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    computed: {
        validations() {

            return {
                usuario: { required: true },
                lotacao: { required: true },
            }
        },
        lotacoes() {

            return this.form.usuarioId === null
                ? []
                : this.usuarios.find(u => u.id === this.form.usuarioId).lotacoes
        },
    },
    data: () => ({
        form: {
            usuarioId: null,
        },
        model: {
            lotacaoId: null,
        },
    }),
    methods: {
        open() {

            this.form.usuarioId = null
            this.model.lotacaoId = null

            if (this.usuarios.length === 1) {

                this.form.usuarioId = this.usuarios[0].id
            }

            this.$refs.Modal.show()
        },
        save() {

            this.$emit('save', this.model.lotacaoId)
            this.close()
        },
        cancel() {

            this.$emit('cancel')
            this.close()
        },
        close() {

            this.$refs.Modal.hide()
        }
    },
    props: {
        usuarios: { type: Array, required: true }
    },
    watch: {
        'form.usuarioId': function () {

            this.model.lotacaoId = null
        },
        'lotacoes': function (lotacoes) {

            if (lotacoes.length === 1) {

                this.model.lotacaoId = lotacoes[0].id
            }
        }
    }
}
</script>